module.exports = __webpack_public_path__ + "img/statsback.fd6edb6c.png";